import {$} from './dom.js';
import {read,write,STORAGE_KEYS} from './storage.js';

export function initMotion({say=()=>{}}={}){
  let off=read(STORAGE_KEYS.MOTION)==='off';
  const preference=matchMedia('(prefers-reduced-motion: reduce)');
  const listeners=new Set();
  const button=$('#motionToggle');
  const render=()=>{
    document.body.classList.toggle('motion-off',off);
    button.setAttribute('aria-pressed',String(!off));
    button.setAttribute('aria-label',`Gentle motion ${off?'off':'on'}${preference.matches?'; system reduced motion is active':''}`);
    $('.motion-label').textContent=off?'Motion off':preference.matches?'Motion reduced':'Motion on';
  };
  const notify=()=>{render();listeners.forEach(listener=>listener({off,reduced:off||preference.matches}));};
  button.addEventListener('click',()=>{
    off=!off;write(STORAGE_KEYS.MOTION,off?'off':'on');notify();
    say(off?'Motion reduced':'Gentle motion on');
  });
  preference.addEventListener('change',notify);render();
  return {isOff:()=>off,isReduced:()=>off||preference.matches,subscribe(listener){listeners.add(listener);return()=>listeners.delete(listener)}};
}
